"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureExpVariation = void 0;
const createApi_1 = require("../../../helpers/createApi");
const schemas_1 = require("./schemas");
const list = (caller) => async ({ account_id, campaign_id, variation_group_id }) => {
    const url = `/accounts/${account_id}/campaigns/${campaign_id}/variation_groups/${variation_group_id}/variations`;
    return caller(url).get().then(schemas_1.FeatureExpVariationsWithPaginationTypeSchema.parse);
};
const get = (caller) => async ({ account_id, campaign_id, variation_group_id, variation_id }) => {
    const url = `/accounts/${account_id}/campaigns/${campaign_id}/variation_groups/${variation_group_id}/variations/${variation_id}`;
    return caller(url).get().then(schemas_1.FeatureExpVariationSchema.parse);
};
const post = (caller) => ({ account_id, campaign_id, variation_group_id, name, allocation, reference, order, editor_type }) => {
    const url = `/accounts/${account_id}/campaigns/${campaign_id}/variation_groups/${variation_group_id}/variations`;
    return caller(url).post({ name, allocation, reference, order, editor_type });
};
const patch = (caller) => ({ account_id, campaign_id, variation_group_id, id, ...variation }) => {
    const url = `/accounts/${account_id}/campaigns/${campaign_id}/variation_groups/${variation_group_id}/variations/${id}`;
    return caller(url).patch({ ...variation });
};
const remove = (caller) => async ({ account_id, campaign_id, variation_group_id, variation_id }) => caller(`/accounts/${account_id}/campaigns/${campaign_id}/variation_groups/${variation_group_id}/variations/${variation_id}`).delete();
exports.featureExpVariation = (0, createApi_1.createAPIFactory)({
    list,
    get,
    post,
    patch,
    delete: remove,
});
//# sourceMappingURL=api.js.map